import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const Jushokakunin = props => {
  return <Dropdown.Static kubunKey='jushokakunin' {...props} />
}
